import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import Modal from 'react-modal';
import { useSelector, useDispatch } from 'react-redux';
import { T, useTranslate } from 'shared/helper/translate';
import useNavigate from '../hooks/useNavigate';
import { resetError } from '../actions';
import { recordUpgradeNowClick } from '../../researcher/helpers/gtm';
var ModalError = function ModalError() {
  var navigate = useNavigate();
  var _useTranslate = useTranslate(),
    t = _useTranslate.t;
  var _useSelector = useSelector(function (state) {
      return state;
    }),
    curie = _useSelector.curie;
  var error = curie.error;
  var dispatch = useDispatch();
  var onClose = function onClose() {
    dispatch(resetError());
  };
  var modalActions = {
    dismiss: onClose,
    'get-help': function getHelp() {
      window.open('https://support.aje.com/hc/en-us/sections/360012386571-AJE-Digital-Services', '_blank');
    },
    'got-it': onClose,
    'upgrade-now': function upgradeNow() {
      onClose();
      recordUpgradeNowClick({
        buttonText: 'Upgrade Now'
      });
      navigate('/rubriq/plan/subscribe');
    }
  };
  return error ? /*#__PURE__*/React.createElement(Modal, {
    appElement: document.querySelector('#researcher-app'),
    isOpen: true,
    overlayClassName: "react-modal-overlay",
    className: "react-modal"
  }, /*#__PURE__*/React.createElement("div", {
    className: "react-modal-header"
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "btn-close",
    onClick: onClose,
    "aria-label": t('close')
  }, /*#__PURE__*/React.createElement("span", {
    "aria-hidden": "true"
  }, "\xD7")), /*#__PURE__*/React.createElement("h1", {
    className: "react-modal-title"
  }, /*#__PURE__*/React.createElement(T, {
    source: error.title
  }))), /*#__PURE__*/React.createElement("div", {
    className: "react-modal-content px-3 pt-3 pb-4 d-flex flex-row"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      marginRight: 12
    }
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: "fa-light fa-circle-exclamation",
    className: "rubriq-react-modal-info-icon"
  })), /*#__PURE__*/React.createElement("div", {
    className: "rubriq-react-modal-content"
  }, /*#__PURE__*/React.createElement(T.md, {
    source: error.content,
    params: error.contentParams
  }))), /*#__PURE__*/React.createElement("div", {
    className: "react-modal-footer"
  }, /*#__PURE__*/React.createElement("button", {
    "aria-label": t(error.primaryBtnText),
    type: "button",
    className: "btn btn-primary btn-squared me-3",
    onClick: modalActions[error.primaryBtnText]
  }, /*#__PURE__*/React.createElement(T, {
    source: error.primaryBtnText
  })), error.secondaryBtnText && /*#__PURE__*/React.createElement("button", {
    "aria-label": t(error.secondaryBtnText),
    type: "button",
    className: "btn btn-secondary btn-squared",
    onClick: modalActions[error.secondaryBtnText]
  }, /*#__PURE__*/React.createElement(T, {
    source: error.secondaryBtnText
  })))) : null;
};
export default ModalError;